import React, { useContext } from 'react';
import FormatSelected from '../Pedido/FormatSelected';
import { ArteFinalContext_v2 } from '../../context/ArteFinalContext_v2';

const DropdownOption = ({ onChange, options, id }) => {
  const { formatSelected } = useContext(ArteFinalContext_v2);

  const selectedOption = options.find((option) => option.value === formatSelected?.formatoId);

  return (
    <div className="custom-select-container">
      <div className="format-selector" id={id}>
        {selectedOption ? (
          <FormatSelected
            selected={true}
            options={options}
            option={selectedOption}
            showIconDropdown={options.length > 1}
            onChange={onChange}
          />
        ) : (
          'Select an option'
        )}
      </div>
    </div>
  );
};

export default DropdownOption;
